import { useState, useEffect } from "react";
import { AlertCircle } from "lucide-react";
import api from "@/lib/api";

export default function BreakingNewsTicker() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    api.get("/breaking-news").then(r => setNews(r.data)).catch(() => {});
  }, []);

  if (!news.length) return null;

  const doubled = [...news, ...news];

  return (
    <div className="bg-slate-900 dark:bg-slate-950 text-white py-2.5 overflow-hidden" data-testid="breaking-news-ticker">
      <div className="flex items-center">
        <div className="flex items-center gap-2 px-4 shrink-0 border-r border-slate-700 mr-4">
          <AlertCircle className="h-4 w-4 text-red-400" />
          <span className="text-xs font-sans font-bold uppercase tracking-[0.2em] text-red-400">Breaking</span>
        </div>
        <div className="overflow-hidden flex-1">
          <div className="ticker-animate flex whitespace-nowrap">
            {doubled.map((item, i) => (
              <span key={`${item.id}-${i}`} className="text-sm font-sans font-medium mx-8 inline-block">
                {item.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
